import { useDispatch } from "react-redux";

const useAppDispatch = () => useDispatch<any>();
export default useAppDispatch;
